// src/utils/maestranze.js
const safeTrim = (v) => (typeof v === 'string' ? v.trim() : v);

const pickFirst = (...vals) => {
  for (const v of vals) {
    if (v == null) continue;
    if (typeof v === 'string' && v.trim()) return v.trim();
    if (Array.isArray(v) && v.length) return v[0];
  }
  return null;
};

// prova a prendere il ruolo del FREELANCE da varie forme comuni
const sniffRoleFromItem = (item) => {
  return pickFirst(
    item?.ruolo,
    item?.my_role,
    item?.freelancer_role,
    item?.ruolo_freelance,
    item?.ruolo_produzione,
    item?.role,
    Array.isArray(item?.ruoli) ? item.ruoli[0] : null,
    item?.mansione
  );
};

// se l’oggetto ha link/associazioni, prova a trovare il record del freelance corrente
const sniffRoleFromLinks = (item, myId) => {
  const links = item?.link ? [item.link] : (Array.isArray(item?.links) ? item.links : []);
  if (!links || !links.length || !myId) return null;
  const mine = links.find(l =>
    (l?.freelancer_id ?? l?.freelance_id ?? l?.user_id) == myId
  );
  return safeTrim(mine?.ruolo || mine?.role || mine?.mansione) || null;
};

const parseDate = (d) => {
  if (!d) return null;
  try {
    const x = new Date(d);
    return isNaN(x.getTime()) ? null : x.toISOString().slice(0, 10);
  } catch { return null; }
};

/**
 * Normalizza un record produzione/maestranza e calcola il ruolo del freelance
 */
export function normalizeProduction(item, myId) {
  if (!item || typeof item !== 'object') return { raw: item, roleForMe: null };

  const roleFromItem  = sniffRoleFromItem(item);
  const roleFromLinks = sniffRoleFromLinks(item, myId);
  const roleForMe     = safeTrim(roleFromLinks || roleFromItem) || null;

  // campi titolo/cliente coerenti
  const title = safeTrim(item?.produzione || item?.title || item?.programma || item?.nome || '');
  const client = safeTrim(item?.cliente || item?.company || item?.emittente || '');

  const start_date = parseDate(item?.data_inizio || item?.start_date || item?.inizio);
  const end_date   = parseDate(item?.data_fine   || item?.end_date   || item?.fine);

  return {
    ...item,
    title,
    client,
    start_date,
    end_date,
    roleForMe,
  };
}
